import getConfig from "next/config"

export function checkImage(tempImage: any, tempTenant: any) {
    const { NEXT_PUBLIC_STATIC_DOMAIN } = getConfig().publicRuntimeConfig

    var default512Logo =
        'https://static.aot.plus/images/aot_logo_markonly_transparent_512x512.png'
    if (
        tempImage.height >= 192 &&
        tempImage.width >= 192 &&
        tempImage.height >= 512 &&
        tempImage.width >= 512
    ) {
        default512Logo = tempImage.src
    }
    var myDynamicManifest = {
        name: tempTenant.name,
        short_name: tempTenant.name,
        icons: [
            {
                src: default512Logo,
                sizes: '512x512',
                type: 'image/png',
                purpose: 'any',
            },
            {
                src: default512Logo,
                sizes: '192x192',
                type: 'image/png',
                purpose: 'any',
            },
        ],
        theme_color: '#FFFFFF',
        background_color: '#FFFFFF',
        start_url: location.href,
        display: 'standalone',
        orientation: 'portrait',
    }

    const stringManifest = JSON.stringify(myDynamicManifest)
    const blob = new Blob([stringManifest], { type: 'application/json' })
    const manifestURL = URL.createObjectURL(blob)

    var linkmanifest = document.createElement('link')
    linkmanifest.href = manifestURL
    linkmanifest.rel = 'manifest'
    document.head.appendChild(linkmanifest)

    var linkapple = document.createElement('link')
    linkapple.rel = 'apple-touch-icon'
    linkapple.href = default512Logo
    document.head.appendChild(linkapple)

    var metaTheme = document.createElement('meta')
    metaTheme.name = 'theme-color'
    metaTheme.content = '#317EFB'
    document.head.appendChild(metaTheme)

    var metaviewport = document.createElement('meta')
    metaviewport.name = 'viewport'
    metaviewport.content = 'width=device-width, initial-scale=1'
    document.head.appendChild(metaviewport)
}